export function generateSearchTokens(text: string): string[] {
    const lower = text.toLowerCase();
    const words = lower.split(/\s+/).filter(Boolean);

    const unique = Array.from(new Set(words));
    unique.push(lower.replace(/ /g, ''));

    return unique;
}
